import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c(
                VRow,
                [
                  _c(
                    VToolbar,
                    { attrs: { flat: "" } },
                    [
                      _c(VToolbarTitle, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "title primary--text text--darken-1 text-no-wrap mt-0",
                          },
                          [_vm._v(" FILTROS ")]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                [
                  _c("select-multiple-unidades", {
                    attrs: { "mapeamento-id": _vm.diagnostico.mapeamento.id },
                    model: {
                      value: _vm.unidadesSelecionadas,
                      callback: function ($$v) {
                        _vm.unidadesSelecionadas = $$v
                      },
                      expression: "unidadesSelecionadas",
                    },
                  }),
                ],
                1
              ),
              _c("relatorio-gerencial-responsabilidade", {
                attrs: {
                  "is-uma-unidade": _vm.isUmaUnidade,
                  unidades: _vm.unidadesSelecionadas,
                  diagnostico: _vm.diagnostico,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }